module.exports = __webpack_public_path__ + "static/media/FallbackCode.42308586.svg";